import Blockly from "blockly";
import {
  ActiveCollectibles,
  Collectibles,
  PassiveCollectibles,
  Tier0ActiveCollectibles,
  Tier0PassiveCollectibles,
  Tier1ActiveCollectibles,
  Tier1PassiveCollectibles,
  Tier2ActiveCollectibles,
  Tier2PassiveCollectibles,
  Tier3ActiveCollectibles,
  Tier3PassiveCollectibles,
  Tier4ActiveCollectibles,
  Tier4PassiveCollectibles
} from '../data';

export const menu = {
  name: (<div className="text"><u>C</u>ollectibles</div>),
  trigger: 'c',
  children: {
    'collectibles': {
      name: (<div className="text">All <u>C</u>ollectibles</div>),
      trigger: 'c',
    },
    'active_item': {
      name: (<div className="text">All <u>A</u>ctive Collectibles</div>),
      trigger: 'a',
    },
    'tier0_active_item': {
      name: (<div className="text">Tier <u>0</u> Active Collectibles</div>),
      trigger: '0',
    },
    'tier1_active_item': {
      name: (<div className="text">Tier <u>1</u> Active Collectibles</div>),
      trigger: '1',
    },
    'tier2_active_item': {
      name: (<div className="text">Tier <u>2</u> Active Collectibles</div>),
      trigger: '2',
    },
    'tier3_active_item': {
      name: (<div className="text">Tier <u>3</u> Active Collectibles</div>),
      trigger: '3',
    },
    'tier4_active_item': {
      name: (<div className="text">Tier <u>4</u> Active Collectibles</div>),
      trigger: '4',
    },

    'passive_item': {
      name: (<div className="text"><u>P</u>assive Collectibles</div>),
      trigger: 'p',
    },
    'tier0_passive_item': {
      name: (<div className="text">Tier <u>0</u> Passive Collectibles</div>),
      trigger: '0',
    },
    'tier1_passive_item': {
      name: (<div className="text">Tier <u>1</u> Passive Collectibles</div>),
      trigger: '1',
    },
    'tier2_passive_item': {
      name: (<div className="text">Tier <u>2</u> Passive Collectibles</div>),
      trigger: '2',
    },
    'tier3_passive_item': {
      name: (<div className="text">Tier <u>3</u> Passive Collectibles</div>),
      trigger: '3',
    },
    'tier4_passive_item': {
      name: (<div className="text">Tier <u>4</u> Passive Collectibles</div>),
      trigger: '4',
    },
  }
}

/* ****************************************************************************************************************
 * Active Items
 ******************************************************************************************************************/
Blockly.Blocks['active_item'] = {
  init: function () {
    this.appendDummyInput()
      .appendField('active item')
      .appendField(new Blockly.FieldDropdown(
        [['Random Active Item', '-1']].concat(
          ActiveCollectibles.sort((a, b) => a[0] > b[0] ? 1 : -1)
        )
      ), 'Item');
    this.setOutput(true, ['active', 'collectible']);
  }
}

Blockly.JSON['active_item'] = (block) => {
  let value = block.getFieldValue('Item');
  return {
    type: 'collectible',
    entity_id: parseInt(value, 10),
  };
}

/* ****************************************************************************************************************
 * Tier X Active Items
 ******************************************************************************************************************/
let activeTierTranslation = {
  0: Tier0ActiveCollectibles,
  1: Tier1ActiveCollectibles,
  2: Tier2ActiveCollectibles,
  3: Tier3ActiveCollectibles,
  4: Tier4ActiveCollectibles,
}

for (let tier = 0; tier < 5; tier++) {
  Blockly.Blocks[`tier${tier}_active_item`] = {
    init: function () {
      this.appendDummyInput()
        .appendField(`tier ${tier} active item`)
        .appendField(new Blockly.FieldDropdown(
          [[`Random Tier ${tier} Active Item`, '-1']].concat(
            activeTierTranslation[tier].sort((a, b) => a[0] > b[0] ? 1 : -1)
          )
        ), 'Item');
      this.setOutput(true, ['active', 'collectible']);
    }
  }

  Blockly.JSON[`tier${tier}_active_item`] = (block) => {
    let value = block.getFieldValue('Item');
    return {
      type: `tier${tier}active`,
      entity_id: parseInt(value, 10),
    };
  }
}

/* ****************************************************************************************************************
 * Collectibles
 *
 * Specifies a Collectible selection output block.
 ******************************************************************************************************************/
Blockly.Blocks['collectibles'] = {
  init: function () {
    this.appendDummyInput()
      .appendField('Collectible')
      .appendField(new Blockly.FieldDropdown(
        Collectibles.sort((a, b) => a[0] > b[0] ? 1 : -1)
      ), 'Collectible');
    this.setOutput(true, ['collectible']);
  }
}

Blockly.JSON['collectibles'] = (block) => {
  let value = block.getFieldValue('Collectible');

  return {
    type: 'collectible',
    entity_id: parseInt(value, 10),
  };
}

/* ****************************************************************************************************************
 * Passive Items
 ******************************************************************************************************************/
Blockly.Blocks['passive_item'] = {
  init: function () {
    this.appendDummyInput()
      .appendField('passive item')
      .appendField(new Blockly.FieldDropdown(
        PassiveCollectibles.sort((a, b) => a[0] > b[0] ? 1 : -1)
      ), 'Item');
    this.setOutput(true, ['passive', 'collectible']);
  }
}

Blockly.JSON['passive_item'] = (block) => {
  let value = block.getFieldValue('Item');
  return {
    type: 'collectible',
    entity_id: parseInt(value, 10),
  };
}

/* ****************************************************************************************************************
 * Tier X Passive Items
 ******************************************************************************************************************/
let passiveTierTranslation = {
  0: Tier0PassiveCollectibles,
  1: Tier1PassiveCollectibles,
  2: Tier2PassiveCollectibles,
  3: Tier3PassiveCollectibles,
  4: Tier4PassiveCollectibles,
}

for (let tier = 0; tier < 5; tier++) {
  Blockly.Blocks[`tier${tier}_passive_item`] = {
    init: function () {
      this.appendDummyInput()
        .appendField(`tier ${tier} passive item`)
        .appendField(new Blockly.FieldDropdown(
          [[`Random Tier ${tier} Passive Item`, '-1']].concat(
            passiveTierTranslation[tier].sort((a, b) => a[0] > b[0] ? 1 : -1)
          )
        ), 'Item');
      this.setOutput(true, ['passive', 'collectible']);
    }
  }

  Blockly.JSON[`tier${tier}_passive_item`] = (block) => {
    let value = block.getFieldValue('Item');
    return {
      type: `tier${tier}passive`,
      entity_id: parseInt(value, 10),
    };
  }
}
